<div class="relative pb-16 bg-white overflow-hidden">
  <div class="mx-auto max-w-7xl relative px-4 sm:px-6 lg:px-8 z-10" *ngIf="blok">
    <div class="mt-6 prose font-body tracking-wide prose-lg prose-blue" [innerHtml]="blok.text_area !== null ? resolveRichText(blok?.text_area) : ''">
    </div>
  </div>
</div>